import React, { FormEvent, useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import Appbar from 'components/appbar/Appbar';
import * as yup from 'yup';
import { api } from 'services/api';
import { useMessaging } from 'providers/messaging';
import history from 'services/history';
import Loading from 'components/loading/Loading';
import InsideLoading from 'components/loading/InsideLoading';
import PlanNewActions from './PlanNewActions';
import PlanForm from '../PlanForm';
import { usePlanValidation } from '../validation/planValidation';
import { Plan } from 'types/plan';
import PLanTabs from '../PlanTabs';
import { Resource } from 'types/resource';
import PlanResources from '../PlanResources';
import PageHeader from 'components/page-header/PageHeader';

const PlanNew: React.FC = () => {
  const [plan, setPlan] = useState<Plan>({} as Plan);
  const [validation, setValidation, validate] = usePlanValidation();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const { handleOpen } = useMessaging();
  const [tab, setTab] = useState(0);
  const [resources, setResources] = useState<Resource[]>([]);

  useEffect(() => {
    api
      .get('/resources')
      .then(response => {
        setResources(response.data);
      })
      .catch(err => {
        console.error(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  function handleChange(index: keyof Plan, value: any) {
    setPlan(oldValue => ({
      ...oldValue,
      [index]: value,
    }));
  }

  function handleValidation(e?: FormEvent<HTMLFormElement>) {
    e?.preventDefault();

    setValidation({});

    validate(plan)
      .then(() => {
        handleSubmit();
      })
      .catch((err: yup.ValidationError) => {
        setValidation({
          [err.path as string]: err.message,
        });
      });
  }

  function handleSubmit() {
    setSaving(true);

    api
      .post(`/plans`, { ...plan, resources })
      .then(() => {
        handleOpen('Salvo');
        setLoading(false);
        history.push('/plans');
      })
      .catch(err => {
        setSaving(false);
        if (err.response) handleOpen(err.response.data.error);
        else handleOpen('Não foi possível salvar o recurso');
      });
  }

  function handleTabChange(value) {
    setTab(value);
  }

  function handleResourceChange(id: number) {
    const updateChildren = (resources: Resource[], state: boolean) =>
      resources.map(resource => {
        resource.enabled = state;
        resource.resources = updateChildren(resource.resources, state);
        return resource;
      });

    const handleSetValue = (resources: Resource[], id: number) =>
      resources.map(resource => {
        if (resource.id === id) {
          resource.enabled = !resource.enabled;
          resource.resources = updateChildren(resource.resources, !!resource.enabled);
        }
        handleSetValue(resource.resources, id);
        return resource;
      });

    const newValue = handleSetValue(resources, id);
    setResources(JSON.parse(JSON.stringify(newValue)));
  }

  return (
    <>
      {saving && <Loading />}

      <Appbar
        backAction={() => history.push('/access-rules')}
        title="Plano"
        ActionsComponent={<PlanNewActions handleSubmit={handleValidation} />}
        Tab={<PLanTabs tab={tab} handleTabChange={value => handleTabChange(value)} />}
      />
      <PageHeader title="Novo plano" />
      {loading ? (
        <InsideLoading />
      ) : tab === 0 ? (
        <Grid container direction="column">
          <Grid item xs={12} lg={4} xl={4} md={6}>
            <form onSubmit={handleValidation}>
              <PlanForm handleChange={handleChange} plan={plan} validation={validation} />
              <button type="submit" style={{ display: 'none' }} />
            </form>
          </Grid>
        </Grid>
      ) : (
        <PlanResources resources={resources} handleResourceChange={handleResourceChange} />
      )}
    </>
  );
};

export default PlanNew;
